@if (type === 'dropdown') {
  @if (!!landingPage) {
    <a [uiSref]="landingPage">
      <button type="button" class="dropdown-item">
        <div class="icon">
          <i class="fa fa-qrcode"></i>
        </div>
        <div class="icon-label">
          Artikelverwaltung
        </div>
      </button>
    </a>
  }
}

@if (type === 'base') {
  @if (!!landingPage) {
    <li>
      <a [uiSref]="landingPage">
        <div class="icon">
          <i class="fa fa-qrcode"></i>
        </div>
        <div class="icon-label">
          Artikelverwaltung
        </div>
      </a>
    </li>
  }
}
